<template>
  <div class="pb-75px">
    <main class="main reception">
      <ValidationObserver v-slot="{ invalid, errors }" ref="validform" slim>
        <form @submit.prevent="next()">
          <div class="section form-group">
            <div class="field-group name flex">
              <FormInput
                type="text"
                name="name"
                v-model="user.name"
                :rules="`required|${kycCdd.national === 'local' ? 'name' : 'name_extend'}`"
                placeholder="대표자(사업자등록증 상)이름을 입력해주세요."
                :disabled="isInputDisabed"
              />
              <p
                v-if="errors.name != null && errors.name[0] != null"
                class="error-text"
              >{{errors.name[0]}}</p>
            </div>

            <div class="field-group birthday mb-0">
              <FormSelect
                class="yyyy"
                type="text"
                name="birthyyyy"
                rules="required|birthyyyy"
                v-model="birthdate.yyyy"
                :options="yyyyOptions"
                :disabled="isInputDisabed"
              />
              <span>년</span>
              <FormSelect
                class="mm"
                type="text"
                name="birthmm"
                rules="required|birthmm"
                v-model="birthdate.mm"
                :options="mmOptions"
                :disabled="isInputDisabed"
              />
              <span>월</span>
              <FormSelect
                class="dd"
                type="text"
                name="birthdd"
                rules="required|birthdd"
                v-model="birthdate.dd"
                :options="ddOptions"
                :disabled="isInputDisabed"
              />
              <span>일</span>
            </div>
            <div class="field-group">
              <p
                v-if="(errors.birthyyyy != null && errors.birthyyyy[0] != null) || (errors.birthmm != null && errors.birthmm[0] != null) || (errors.birthdd != null && errors.birthdd[0] != null)"
                class="error-text"
              >{{errors.birthyyyy[0] || errors.birthmm[0] || errors.birthdd[0]}}</p>
            </div>
            <div class="field-group gender">
              <button
                v-ripple
                type="button"
                @click="selectGender('male')"
                name="gender"
                :class="{'selected': user.gender === 'male'}"
              >남자</button>
              <button
                v-ripple
                type="button"
                @click="selectGender('female')"
                name="gender"
                :class="{'selected': user.gender === 'female'}"
              >여자</button>
            </div>
            <div class="field-group national">
              <button
                v-ripple
                type="button"
                @click="selectNational('local')"
                name="national"
                :class="{'selected': kycCdd.national === 'local'}"
              >내국인</button>
              <button
                v-ripple
                type="button"
                @click="selectNational('foreigner')"
                name="national"
                :class="{'selected': kycCdd.national === 'foreigner'}"
              >외국인</button>
            </div>
            <div class="field-group phone">
              <FormSelect
                name="mobile_carrier"
                rules="required"
                v-model="user.mobile_carrier"
                :options="mobileCarriers"
                :disabled="isInputDisabed"
              />
              <FormInput
                type="tel"
                name="phone"
                v-model="user.phone"
                @input="inputPhoneNum()"
                rules="required|numeric|phone"
                placeholder="대표자 전화번호"
                :disabled="isInputDisabed"
              />
            </div>
            <div class="field-group phone"
                 v-if="(errors.mobile_carrier != null && errors.mobile_carrier[0] != null) || (errors.phone != null && errors.phone[0] != null)">
              <p class="error-text"
                style="margin-top: 0px;"
              >{{errors.mobile_carrier != null && errors.mobile_carrier.length > 0 ? errors.mobile_carrier[0] : errors.phone[0]}}</p>
            </div>
            <div class="field-group name">
              <FormInput
                type="text"
                name="email"
                rules="required|email"
                v-model="user.email"
                placeholder="이메일 주소를 입력해주세요."
                :disabled="isInputDisabed"
              />
            </div>
            <div class="field-group address flex">
              <FormInput
                @click="address()"
                type="text"
                readonly="readonly"
                name="address"
                style="cursor: pointer;"
                v-model="store.address1"
                rules="required"
                placeholder="사업장 주소를 입력해주세요."
              />
              <p
                v-if="errors.address != null && errors.address[0] != null"
                class="error-text"
              >{{errors.address[0]}}</p>
            </div>
            <div
              :style="{'display': daumPostcodeShow == true ? 'block' : 'none'}"
              class="field-group flex"
              id="btnFoldWrap"
              style="text-align: right;"
            >
              <img
                src="../../assets/images/btn-close.svg"
                style="cursor:pointer;"
                @click="addressFold"
                alt="접기 버튼"
              />
            </div>
            <div
              :class="daumPostcodeShow == true ? 'daum-post-wrapper-active' : 'daum-post-wrapper'"
              id="daumPostcodeWrap"
              style="margin:5px 0;position:relative;width:100%;"
            ></div>
            <div class="field-group" v-show="store.address1 != null && store.address1 != ''">
              <FormInput
                v-model="store.address2"
                placeholder="상세 주소를 입력해주세요."
                name="detail_address"
                :class="{'input-bold' : addrDetail != null && addrDetail != ''}"
                :disabled="isExistingCustomer"
                ref="address2"
                type="text"
              />
            </div>
            <div class="field-group type-of-business">
              <FormSelect
                name="type_of_business"
                rules="required"
                v-model="kycEdd.type_of_business"
                :options="businessTypes"
                :placeholder="'업종을 알려주세요'"
              />
            </div>
            <div class="field-group purposes-of-loan">
              <FormSelect
                name="purposes_of_loan"
                rules="required"
                v-model="kycEdd.purposes_of_loan"
                :options="loanPurposes"
                :placeholder="'대출목적을 알려주세요'"
              />
            </div>
          </div>
          <div class="section bottom">
            <button
              v-ripple
              class="button next-button"
              :disabled="invalid||isInProgress"
              type="submit"
            >
              다음
              <v-progress-circular
                style="padding-left: 15px;"
                size="24"
                v-if="isInProgress"
                indeterminate
                color="primary"
              ></v-progress-circular>
            </button>
          </div>
        </form>
      </ValidationObserver>
    </main>
  </div>
</template>
<script>
import AuthService from '@/service/auth/AuthService'
import UserService from '@/service/user/UserService'
import KycService from '@/service/kyc/KycService'
import FormInput from '@/components/form/FormInput'
import FormSelect from '@/components/form/FormSelect'
import JsUtil from '@/util/JsUtil'

// Function Section
// Add Function Section
const addBirthdate = function (birthdate) {
  if (!birthdate) return null
  const yyyy = getDigitedNumber(birthdate.yyyy, 4)
  const mm = getDigitedNumber(birthdate.mm, 2)
  const dd = getDigitedNumber(birthdate.dd, 2)
  const result = `${yyyy}-${mm}-${dd}`
  return result
}

// Get Function Section
const getDigitedNumber = function (num, digits) {
  num = num || 0
  return ('0'.repeat(digits) + num.toString()).slice(-digits)
}

export default {
  components: {
    FormInput, FormSelect
  },
  data() {
    return {
      addr: null,
      addrDetail: null,
      isExistingCustomer: false,
      isInputDisabed: false,
      user: {
        name: null,
        email: null,
        mobile_carrier: null,
        purposes_of_loan: null,
        gender: 'male',
        phone: null,
        birthdate: null
      },
      birthdate: {
        yyyy: null,
        mm: null,
        dd: null
      },
      store: {
        address1: null,
        address2: null,
        type_of_business: null,
        zip_code: null
      },
      kycCdd: {
        national: 'local',
        name: null,
        birthdate: null,
        address: null,
      },
      kycEdd: {
        type_of_business: null,
        purposes_of_loan: null,
      },
      isInProgress: false,
      mobileCarriers: [{
        label: '통신사',
        value: ''
      }, {
        label: 'SKT',
        value: 'skt'
      }, {
        label: 'KT',
        value: 'kt'
      }, {
        label: 'LG+',
        value: 'lg'
      }, {
        label: 'SKT 알뜰폰',
        value: 'mvno_skt'
      }, {
        label: 'KT 알뜰폰',
        value: 'mvno_kt'
      }, {
        label: 'LG+ 알뜰폰',
        value: 'mvno_lg'
      }],
      businessTypes: [
        {
          label: '요식업',
          value: '요식업'
        },
        {
          label: '도/소매업',
          value: '도/소매업'
        },
        {
          label: '서비스업',
          value: '서비스업'
        },
        {
          label: '기타',
          value: '기타'
        }
      ],
      loanPurposes: [
        {
          label: '가게 운영 자금',
          value: '가게 운영 자금'
        },
        {
          label: '생활비',
          value: '생활비'
        },
        {
          label: '타 금융 대환',
          value: '타 금융 대환'
        },
        {
          label: '기타',
          value: '기타'
        }
      ],
      daumPostcodeShow: false,
      isDaumPostcodeInitialize: false,
      profileName: null
    }
  },
  async created() {
    this.$store.commit('ui/headerTitle', '본인 확인하기')
    let profile = AuthService.getProfile()
    this.user.mobile_carrier = profile.mobile_carrier
    this.user.phone = profile.phone
    this.user.email = profile.email
    this.kycEdd.purposes_of_loan = profile.purposes_of_loan
    this.kycEdd.type_of_business = profile.store.type_of_business
    this.user.gender = profile.gender === '' ? 'male' : profile.gender
    // Set birthdate
    if (profile.birthdate) {
      this.user.name = profile.name
      // profile 에 있는 이름 원본 기록
      this.profileName = profile.name

      const birthdates = this._.split(profile.birthdate, '-')
      this.birthdate['yyyy'] = birthdates[0] || 1900
      this.birthdate['mm'] = birthdates[1] || 1
      this.birthdate['dd'] = birthdates[2] || 1
      this.isInputDisabed = true
    }
    this.store.address1 = profile.store.address1
    this.store.address2 = profile.store.address2
    this.store.zip_code = profile.store.zip_code
    this.isExistingCustomer = await UserService.isExistingCustomer()

    this.$nextTick(_ => {
      this.$refs.validform.validate()
    })
  },
  watch: {
    'user.name': function (value) {
      this.replaceSpaceName(value)
    },
  },
  computed: {
    userBirthdate: function () {
      const value = addBirthdate(this.birthdate)
      return value
    },
    yyyyOptions: function () {
      let ddArray = []
      let startYear = new Date().getFullYear()
      let endYear = 1900
      for (let i = startYear; i >= endYear; i--) {
        ddArray.push({
          label: i,
          value: i,
        })
      }
      return ddArray
    },
    mmOptions: function () {
      let mmArray = []
      let endMonth = 12
      for (let i = 1; i <= endMonth; i++) {
        let formatValue = i >= 10 ? i : '0' + i
        mmArray.push({
          label: formatValue,
          value: formatValue
        })
      }
      return mmArray
    },
    ddOptions: function () {
      let ddArray = []
      let endDay = 31
      for (let i = 1; i <= endDay; i++) {
        let formatValue = i >= 10 ? i : '0' + i
        ddArray.push({
          label: formatValue,
          value: formatValue
        })
      }
      return ddArray
    },
  },
  methods: {
    replaceSpaceName(value) {
      // 외국인이면 공백 허용
      if (this.kycCdd.national === 'local') {
        this.user.name = value.replace(/\s/g, '')
      } else {
        this.user.name = value.trim()
      }
    },
    selectGender(select) {
      if (!this.isInputDisabed) {
        this.user.gender = select
      }
    },
    selectNational(select) {
      if (!this.isInProgress) {
        this.kycCdd.national = select

        // 이름을 입력받지 않고 프로필 이름 사용하는 경우 이름 재설정
        if (this.profileName) {
          this.replaceSpaceName(this.profileName)
        }
      }
    },
    async next() {
      if (this.isInProgress === true || this.$refs.validform.flags.invalid === true) {
        return
      }

      this.user.birthdate = this.userBirthdate
      this.user.purposes_of_loan = this.kycEdd.purposes_of_loan

      this.store.type_of_business = this.kycEdd.type_of_business

      this.user.name = this.user.name.trim()
      this.kycCdd.name = this.user.name
      this.kycCdd.birthdate = this.user.birthdate
      this.kycCdd.address = `${this.store.address1} ${this.store.address2} (${this.store.zip_code})`

      this.isInProgress = true
      try {
        await UserService.patchUserStore(this.store)
      } catch (e) {
        console.error(e, 'patchUserStore')
        this.isInProgress = false
        return
      }

      try {
        await UserService.patchUser(this.user)
        await KycService.postCdd(this.kycCdd)
        await KycService.postEdd(this.kycEdd)
        let redirectPage = location.origin + '/kyc/verify-id'
        let { data } = await KycService.postMobileAuthUrl(redirectPage)
        if (navigator.userAgent.match(/Android/i)) {
          document.location.replace(data)
        } else {
          location.href = data
        }
      } catch (e) {
        console.error(e, 'patchUser')
        if (e && e.data != null) {
          alert(e.data[Object.getOwnPropertyNames(e.data)[0]][0])
          if (e.data.phone != null && e.data.phone[0] === '사용자의 전화번호은/는 이미 존재합니다.') {
            this.$refs.validform.setErrors({
              phone: ['이미 등록되어 있는 전화번호입니다.']
            })
          }
        }
        this.isInProgress = false
      }
    },
    addressFold() {
      this.daumPostcodeShow = false
    },
    address() {
      if (this.daumPostcodeShow === true) {
        return
      } else if (this.isDaumPostcodeInitialize === true) {
        this.daumPostcodeShow = true
        return
      }
      let elementWrap = document.getElementById('daumPostcodeWrap')
      JsUtil.loadasync({
        id: 'daumPostcode',
        src: '//spi.maps.daum.net/imap/map_js_init/postcode.v2.js?autoload=false'
      }).then(_ => {
        console.log('daumPostcode init')
        this.isDaumPostcodeInitialize = true
        window.daum.postcode.load(_ => {
          new window.daum.Postcode({
            oncomplete: data => {
              let addr = ''

              if (data.userSelectedType === 'R') { // 사용자가 도로명 주소를 선택했을 경우
                addr = data.roadAddress
              } else { // 사용자가 지번 주소를 선택했을 경우(J)
                addr = data.jibunAddress
              }

              this.store.address1 = addr
              this.store.zip_code = data.zonecode
              console.log(data, addr)
              // // 임시적으로 1초뒤에 호출하게 바꾼다.
              // setTimeout(() => {
              //   document.getElementsByName('detail_address')[0].focus()
              // }, 1000)
              // setTimeout(() => {
              //   $this.$refs.address2.$el.focus()
              // }, 1000)
              this.daumPostcodeShow = false
              this.isDaumPostcodeInitialize = false
            },
            // 우편번호 찾기 화면 크기가 조정되었을때 실행할 코드를 작성하는 부분. iframe을 넣은 element의 높이값을 조정한다.
            onresize: function (size) {
              elementWrap.style.height = size.height + 'px'
            },
            width: '100%',
            height: '100%'
            // ,
            // onclose: () => {
            //   console.log($this.$refs.validform.fields.address)
            // }
          }).embed(elementWrap)

          this.daumPostcodeShow = true
        })
      })
    },
    inputPhoneNum() {
      let phone = this.user.phone
      if (phone != null && phone.length > 0) {
        this.user.phone = phone.replace(/[^\d]/g, '')
      }
    }
  }
}
</script>
<style lang="scss" scoped>

.red-border {
  border-color: #ff1616;
}

.form-group {
  padding-bottom: 30px;

  .address {
    z-index: 9999;
  }

  .daum-post-wrapper-active {
    display: block;
    border: none !important;
    margin-bottom: 30px !important;
  }

  .daum-post-wrapper {
    display: none;
  }
}

.form-group {
  padding-bottom: 30px;
}

select {
  border-style: solid;
}
</style>
